import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectFormDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Link from="/$organizationId/$projectId/forms/$formId/" to="/$organizationId/$projectId/forms">
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Forms
					</Button>
				</Link>
			}
		/>
	)
})
ProjectFormDetailViewTopBar.displayName = "ProjectFormDetailViewTopBar"
